import { ApolloClient, InMemoryCache, split, HttpLink, ApolloLink } from "@apollo/client";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { getMainDefinition } from "@apollo/client/utilities";

const removeTypename = (key: unknown, value: unknown) => (key === "__typename" ? undefined : value);

const removeTypenameLink = new ApolloLink((operation, forward) => {
	return forward(operation).map((response) => {
		if (response.data) {
			response.data = JSON.parse(JSON.stringify(response.data), removeTypename);
		}
		return response;
	});
});

const httpLink = new HttpLink({
	uri: `${import.meta.env.VITE_APP_AWS_APPSYNC_RTC}graphql`,
});

const subscriptionLink = import.meta.env.VITE_APP_AWS_APPSYNC_RTC.replace("http", "ws");

const wsLink = new GraphQLWsLink(
	createClient({
		url: subscriptionLink,
	})
);

const splitLink = split(
	({ query }) => {
		const definition = getMainDefinition(query);
		return definition.kind === "OperationDefinition" && definition.operation === "subscription";
	},
	wsLink,
	httpLink
);

const apolloLink = ApolloLink.from([removeTypenameLink, splitLink]);

const apolloClient = new ApolloClient({
	link: apolloLink,
	cache: new InMemoryCache(),
});

export default apolloClient;
